import vars from "../helpers";

const init = () => {
	const $project = vars.$document.find('.project');
	const $mainSlider = document.querySelector('.project__slider--1');
	const $supSlider = document.querySelector('.project__slider--2');

	var swiper = new Swiper($supSlider, {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 4,
		// freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});

	var swiper2 = new Swiper($mainSlider, {
		loop: true,
		spaceBetween: 0,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		thumbs: {
			swiper: swiper,
		},
	});

	const $mainSlider1 = document.querySelector('.project__slider--3');
	const $supSlider1 = document.querySelector('.project__slider--4');

	var swiper3 = new Swiper($supSlider1, {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 4,
		// freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});

	var swiper4 = new Swiper($mainSlider1, {
		loop: true,
		spaceBetween: 0,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		thumbs: {
			swiper: swiper3,
		},
	});
};

export default {
	init
};
